module.exports = __webpack_public_path__ + "img/traffic-junction-2.d46c8e2d.webp";